import { render, staticRenderFns } from "./DetailSync.vue?vue&type=template&id=1a98c84a&"
import script from "./DetailSync.vue?vue&type=script&lang=js&"
export * from "./DetailSync.vue?vue&type=script&lang=js&"
import style0 from "./DetailSync.vue?vue&type=style&index=0&id=1a98c84a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports